import React, { useLayoutEffect, useContext } from "react";
import ApiFile from "../../../app/api/admin/file/ApiFile";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import useListFilters from "../../modules/list/useListFilters";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import InputText from "../../components/inputs/text";
import InputNumber from "../../components/inputs/number/number";
import ButtonLinkShow from "../../components/button-link/__show";
import ButtonLinkAdd from "../../components/button-link/__add";
import FileLib from "../../../inc/FileLib";

// Список APK-файлов.
export default function FilesIndex({ ...other }) {
    return <Page {...other}>
        <FilesIndexContent/>
    </Page>;
}

function FilesIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    const filter = useListFilters(['id', 'name']);

    useLayoutEffect(() => {
        contextContent.setTitle('APK-файлы');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const header = [
        <ListHeaderItem key="id" name="id">ID</ListHeaderItem>,
        <ListHeaderItem key="name" name="name">Имя файла</ListHeaderItem>,
        <ListHeaderItem key="size" name="size" isSort={false}>Размер</ListHeaderItem>,
        <ListHeaderItem key="dir" name="dir" isSort={false}>Каталог</ListHeaderItem>,
        <ListHeaderItem key="public_url" name="public_url" isSort={false}>Ссылка</ListHeaderItem>,
        <ListHeaderItem key="create" name="create" isSort={false}>
            {contextContent.checkPermission('create')
                ? <ButtonLinkAdd className="button-link_white" title="Загрузить APK" href={contextPage.routes.create.url()}/> : null}
        </ListHeaderItem>,
    ];

    const filters = [
        <InputNumber className="input_wf" value={filter.values.id} onChange={(e) => filter.setValue('id', e.target.value)}>id</InputNumber>,
        <InputText className="input_wf" value={filter.values.name} onChange={(e) => filter.setValue('name', e.target.value)}>Имя файла</InputText>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="id">{row.id}</ListBodyItem>,
        <ListBodyItem key="name">
            {row.name}
            {/* У APK — версия приложения (versionName из манифеста, считает бэкенд); у остальных null. */}
            {row.version ? <>{' '}<span className="badge" title="Версия приложения (versionName)">{row.version}</span></> : null}
        </ListBodyItem>,
        <ListBodyItem key="size">{FileLib.formatterSize(row.size) ?? '—'}</ListBodyItem>,
        <ListBodyItem key="dir">{row.dir ?? '—'}</ListBodyItem>,
        <ListBodyItem key="public_url">
            <a href={row.public_url} target="_blank" rel="noopener noreferrer" title="Скачать">Скачать</a>
        </ListBodyItem>,
        <ListBodyItem key="show">
            {contextContent.checkPermission('show')
                ? <ButtonLinkShow className="button-link_blue" title="Просмотр" href={contextPage.routes.show.url({ id: row.id })}/> : null}
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiFile}
        renderRow={renderRow}
        filters={filters}
        defaultSortKey="id"
        defaultSortIsAsc={false}
        // type_file жёстко: без него выдачу забивают скриншоты устройств (type_file=img,
        // их пишет DeviceScreenshotSnapshot) — см. FileFilter в API.
        searchParams={{ type_file: 'apk', ...filter.applied }}
        onApplyFilters={filter.apply}
        onResetFilters={filter.reset}
    />;
}
